import React, { Component } from "react";
import $ from "jquery";
import {
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  FormText,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Header from "../components/Header";
import AuthHOC from "./Auth";
import { connect } from "react-redux";
import { withAlert } from "react-alert";
import classnames from "classnames";
import MissingDataConfigModal from "../components/modals/MissingDataConfigModal";
import CertificatesUploadModal from "../components/modals/CertificatesUploadModal";
import SmtpConfigTable from "../components/tables/SmtpConfigTable";
import NewMultiSMTPConfigModal from "../components/modals/NewMultiSMTPConfigModal";

class Config extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      selectedTab: "system",
      tabItems: [],
      newResults: {},
      activeTab: 0,
      missingDataModalVisible: false,
      uploadCertificateModalVisible: false,
      addSMTPConfigModalVisible: false,
      smtpConfig: null,
      smtpLength: null,
    };
  }

  
  componentDidMount = () => {
    fetch(
      window.location.protocol +
        "//" +
        window.location.host +
        "/api/config/get_config"
    )
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ result });
        },
        (error) => {
          this.setState({
            error: true,
          });
        }
      );
    fetch(
      window.location.protocol +
        "//" +
        window.location.host +
        "/api/config/get_about"
    )
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            about: result,
          });
        },
        (error) => {
          this.setState({
            error: true,
          });
        }
      );
  };

  handleSubmit = (event) => {
    fetch(
      window.location.protocol +
        "//" +
        window.location.host +
        "/api/config/set_config_settings",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: this.state.selectedTab,
          settings: this.state.result,
        }),
      }
    )
      .then((res) => res.json())
      .then((result) => {
        this.props.alert.success(result.message);
        if (result.restart)
          this.props.alert.info("An application restart is required");
      });

    event.preventDefault();
  };

  getMultiSMTPDetails = () => {
    fetch(
      window.location.protocol +
        "//" +
        window.location.host +
        "/api/config/get_db_config?type=smtp"
    )
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            smtpConfig: {
              ...result,
              settings: [...result.settings]
            }
          });
        },
        (error) => {
          this.setState({
            error: true,
          });
        }
      );
  };

  refresh = () => {
    this.getMultiSMTPDetails();
  };

  onRowClicked = (row) => {
  };

  handleInputChange = (event) => {
    let target = event.target;
    let value = target.value;
    let name = target.name;

    if (target.type == "checkbox") value = target.checked;

    let newResult = this.state.result;
    newResult[this.state.selectedTab][name] = value;

    this.setState({
      result: newResult,
    });
  };

  toggle = (tab, id) => {
    if (this.state.activeTab !== id) {
      if (tab == "smtp") {
        this.getMultiSMTPDetails();
      }
      this.setState({
        activeTab: id,
        selectedTab: tab,
      });
    }
  };

  sendTestEmail = () => {
    fetch(
      window.location.protocol +
        "//" +
        window.location.host +
        "/api/email/send_test_email",
      {
        method: "POST",
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if (result.error) this.props.alert.error(result.message);
        else this.props.alert.success(result.message);
      });
  };

  enableMutiSMTP = () => {
    fetch("/api/config/enable_multi_smtp", {
      method: "POST",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.error) this.props.alert.error(result.message);
        else {
          this.getMultiSMTPDetails();
          this.props.alert.success("Multi SMTP server's enabled");
        }
      });
  };

  addNewSMTPServer = () => {
    const data = {
      type: "smtp",
      host: "",
      emailFrom: "",
      replyTo: "",
      port: "",
      secure: false,
      ignoreTLS: false,
      username: "",
      password: "",
      requireTLS: true,
      tlsServerName: "",
      admin_address: "",
      folder: "FOLDER",
      isDefault: false,
      settingsid: this.state.smtpConfig.settings.length + 1
    };

      this.setState(prev => ({
      smtpConfig: {
        ...prev.smtpConfig,
        settings: [...prev.smtpConfig.settings, data]
      }
    }));

    this.toggleSMTPConfigModal();
  };

  toggleSMTPConfigModal = () => {
    if (this.state.addSMTPConfigModalVisible) this.getMultiSMTPDetails();

    this.setState({
      addSMTPConfigModalVisible: !this.state.addSMTPConfigModalVisible,
    });
  };

  displayMissingDataModal = () => {
    this.setState({
      missingDataModalVisible: !this.state.missingDataModalVisible,
    });
  };

  toggleCertificateUploadModal = () => {
    this.setState({
      uploadCertificateModalVisible: !this.state.uploadCertificateModalVisible,
    });
  };

  activeTabChange = () => {};

  render() {
    const { parsed, localisation } = this.props;
    let content = [];
    content.push(<div />);

    if (this.state.result) {
      for (var key in this.state.result) {
        var attrName = key;
        var attrValue = this.state.result[key];

        if (attrValue.amendable && !this.state.tabItems.includes(attrName))
          this.state.tabItems.push(attrName);

        if (attrValue.amendable && this.state.selectedTab == attrName) {
          for (var obj in attrValue) {
            var name = obj;
            var value = attrValue[obj];

            if (name == "amendable") continue;

            if (this.state.selectedTab == "smtp" && this.state.smtpConfig) {
              content.push(
                <SmtpConfigTable
                  id={this.state.smtpConfig._id}
                  logs={this.state.smtpConfig.settings}
                  refresh={() => this.getMultiSMTPDetails()}
                  columnConfig={{ actions: true }}
                />
              );
              break;
            }

            if (typeof value == "string" && (name !== "password" && name !== "secret")) {
              content.push(
                <FormGroup>
                  <Label for={name}>{name}</Label>
                  <Input
                    type="text"
                    name={name}
                    autoComplete="false"
                    value={value}
                    onChange={this.handleInputChange}
                    className="config-form-control"
                  />
                </FormGroup>
              );
            } else if (typeof value == "string" && (name == "password" || name == "secret")) {
              content.push(
                <FormGroup>
                  <Label for={name}>{name}</Label>
                  <Input
                    type="password"
                    name={name}
                    autoComplete="false"
                    defaultValue={""}
                    onChange={this.handleInputChange}
                    className="config-form-control"
                  />
                </FormGroup>
              );
            } else if (typeof value == "boolean") {
              content.push(
                <FormGroup>
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={value}
                      name={name}
                      onChange={this.handleInputChange}
                    />{" "}
                    {name}
                  </Label>
                </FormGroup>
              );
            } else {
              content.push(
                <FormGroup>
                  <Label for={name}>{name}</Label>
                  <Input
                    type="text"
                    name={name}
                    value={value}
                    autoComplete="false"
                    onChange={this.handleInputChange}
                    className="config-form-control"
                  />
                </FormGroup>
              );
            }
          }
        }
      }
    }

    let tab_items = [];

    this.state.tabItems.forEach((tabItem, i) => {
      tab_items.push(
        <NavLink
          className={classnames({ active: this.state.activeTab === i })}
          onClick={() => {
            this.toggle(tabItem, i);
          }}
        >
          {tabItem}
        </NavLink>
      );
    });

    if (this.state.about) {
      tab_items.push(
        <NavLink
          className={classnames({
            active: this.state.activeTab === this.state.tabItems.length,
          })}
          onClick={() => {
            this.toggle(null, this.state.tabItems.length);
          }}
        >
          {"about"}
        </NavLink>
      );

      if (this.state.activeTab === this.state.tabItems.length) {
        content.push(
          <FormGroup>
            <Label>{"Version: " + this.state.about.version}</Label>
          </FormGroup>
        );

        content.push(
          <FormGroup>
            <Label>{"Packages:"}</Label>
          </FormGroup>
        );

        for (const key in this.state.about.packages) {
          content.push(
            <FormGroup>
              <Label>{key + " - " + this.state.about.packages[key]}</Label>
            </FormGroup>
          );
        }
      }
    }

    return (
      <div className="App">
        <Header visible={!this.props.parsed.X3} />
        <content>
          <p className="s-ldp-title">
            {localisation["configuration_header"]
              ? localisation["configuration_header"].element_lang
              : "Configuration"}
          </p>
          <br />
          <Nav tabs style={{ display: "flex", justifyContent: "center" }}>
            <NavItem style={{ display: "inline-flex" }}>{tab_items}</NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId={this.state.activeTab}>
              <Form
                onSubmit={this.handleSubmit}
                style={{ marginTop: "15px", marginBottom: "15px" }}
              >
                {content}
                {this.state.selectedTab == "system" && (
                  <FormGroup >
                    <Button
                      color="success"
                      onClick={() => this.toggleCertificateUploadModal()}
                    >
                      {localisation["upload_cretificate_button"]
                        ? localisation["upload_cretificate_button"].element_lang
                        : "Upload Certificates"}
                    </Button><br />
                  </FormGroup>
                )}
                {this.state.selectedTab == "smtp" && (
                  <>
                    {this.state.smtpConfig ? (
                      <FormGroup>
                        <Button
                          color="primary"
                          onClick={() => this.addNewSMTPServer()}
                        >
                          {localisation["new_email_button"]
                            ? localisation["new_email_button"].element_lang
                            : "Add Email Configuration"}
                        </Button>
                      </FormGroup>
                    ) : (
                      <>
                        <FormGroup>
                          <Button
                            color="success"
                            onClick={() => this.sendTestEmail()}
                          >
                            {localisation["test_email_button"]
                              ? localisation["test_email_button"].element_lang
                              : "Send Test Email"}
                          </Button>
                        </FormGroup>
                        <FormGroup>
                          <Button
                            color="info"
                            onClick={() => this.enableMutiSMTP()}
                          >
                            {localisation["multiple_smtp_button"]
                              ? localisation["multiple_smtp_button"]
                                  .element_lang
                              : "Enable Multi SMTP"}
                          </Button>
                        </FormGroup>
                      </>
                    )}
                  </>
                )}
                {this.state.selectedTab == "smtp" && this.state.smtpConfig ? (
                  <div />
                ) : (
                  <Button type="submit" color="primary">
                    {localisation["save_button"]
                      ? localisation["save_button"].element_lang
                      : "Save"}
                  </Button>
                )}
              </Form>
            </TabPane>
          </TabContent>
          <br />
        </content>
        {this.state.missingDataModalVisible && (
          <MissingDataConfigModal
            visible={this.state.missingDataModalVisible}
            toggle={this.displayMissingDataModal}
          />
        )}
        {this.state.uploadCertificateModalVisible && (
          <CertificatesUploadModal
            visible={this.state.uploadCertificateModalVisible}
            toggle={this.toggleCertificateUploadModal}
          />
        )}
        {this.state.addSMTPConfigModalVisible && (
          <NewMultiSMTPConfigModal
            visible={this.state.addSMTPConfigModalVisible}
            toggle={this.toggleSMTPConfigModal}
            fileid={this.state.smtpConfig._id}
            settings={
              this.state.smtpConfig.settings[
                this.state.smtpConfig.settings.length - 1
              ]
            }
            settingsId={this.state.smtpConfig.settings.length - 1}
            type={this.state.smtpConfig.type}
            refresh={this.refresh}
          />
        )}
      </div>
    );
  }
}

export default connect((state) => state)(
  AuthHOC(withAlert()(Config), { name: "configuration" })
);
